var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartWithDot = function SvgCartWithDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF3F7",
    fillRule: "evenodd",
    d: "M10.608 3.388H3.822l-.267-.76a1.49 1.49 0 0 0-.82-.886L1.49 1.338c-.37-.156-.79.034-.938.425-.148.39.032.834.403.989l1.245.405.41 1.166a1 1 0 0 0 .07.148l1.98 7.653c.198.622.75 1.042 1.372 1.042h8.336c.622 0 1.175-.42 1.372-1.042l1.014-4.05a4.4 4.4 0 0 1-1.582.357l-.804 3.212H6.032L4.346 4.911h6.314a4.5 4.5 0 0 1-.052-1.523m.538 2.806h-4.27c-.4 0-.722.341-.722.761s.323.762.722.762h5.706a4.46 4.46 0 0 1-1.436-1.523m-3.563 3.978c-.4 0-.722-.341-.722-.761s.323-.762.722-.762h5.043c.4 0 .722.341.722.762 0 .42-.323.761-.722.761zm2.105 5.141c0-.774-.634-1.402-1.414-1.402s-1.413.628-1.413 1.402c0 .775.633 1.403 1.413 1.403s1.414-.628 1.414-1.403m2.826-1.402c.78 0 1.414.628 1.414 1.402 0 .775-.634 1.403-1.414 1.403s-1.413-.628-1.413-1.403c0-.774.633-1.402 1.413-1.402",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 4,
    r: 3,
    fill: "#69C46F"
  })));
};
export default SvgCartWithDot;